import Clip from '../core/Clip';
import MidiNode from '../core/MidiNode';
import * as Tone from 'tone';
class MIDIClip extends Clip {
    constructor() {
        super(...arguments);
        this.outputNode = new MidiNode();
        this.buffer = new Tone.Part();
        this.callback = (audioContextTime, event) => {
            this.output.triggerAttack(event.value, audioContextTime, event.velocity / 127);
            const noteOffTime = Tone.Time(event.duration).toSeconds() + audioContextTime;
            this.output.triggerRelease(noteOffTime, event.value);
        };
    }
    get output() {
        return this.outputNode;
    }
    connect(destination) {
        this.outputNode.connect(destination);
    }
    disconnect() {
        this.outputNode.disconnect();
    }
    at(time) { return this.buffer.at(time); }
    add(time, note, duration, velocity) {
        this.buffer.add({
            time,
            value: note,
            duration: duration || '16n',
            velocity: velocity || 100
        });
    }
    insert(...args) {
        if (Array.isArray(args[0])) {
            for (const note of args[0]) {
                this.add(note[0], note[1], note[2], note[3]);
            }
        }
        else {
            this.add(args[0], args[1], args[2], args[3]);
        }
    }
    start(transportTime) {
        if (transportTime === undefined) {
            transportTime = Tone.now();
        }
        this.buffer.set({
            callback: this.callback,
            loop: this.loop,
            loopStart: this.loopStart.toSeconds(),
            loopEnd: this.loopEnd.toSeconds()
        });
        this.buffer.start(transportTime, this._loopStart + this.startRelative);
        super.start.call(this, transportTime);
    }
    stop(transportTime) {
        this.buffer.stop(transportTime);
        super.stop.call(this, transportTime);
    }
}
export default MIDIClip;
//# sourceMappingURL=MIDIClip.js.map